import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import {  UserService } from '@bt/core';


@Directive({
    selector: '[myHideIfHasNotPermission]'
})
export class MyHideIfHasNotPermissionDirective implements OnInit {
    @Input('myHideIfHasNotPermission') permission: string; // Required permission passed in
 
    constructor(private el: ElementRef,
        private userService: UserService) { }
 
    ngOnInit() {

        if (!this.verifyRole(this.permission)) {
            this.el.nativeElement.style.display = 'none';
        }
    }

    public verifyRole(rolesStr:string) : boolean{
        if(!rolesStr){
            return false;
        }
        var roles = rolesStr.split(',');
        if(roles.indexOf(this.userService.getRole().toString())==-1 ) {
            return false;
        }
        else {
            return true;
        }
    }
}







// WEBPACK FOOTER //
// ./src/app/directives/hide.directive.ts